import { render, staticRenderFns } from "./AppDeleteLabelDialog.vue?vue&type=template&id=a0eff278"
import script from "./AppDeleteLabelDialog.vue?vue&type=script&lang=js"
export * from "./AppDeleteLabelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports